module.exports = __webpack_public_path__ + "img/bicycle.fb3db7a3.jpg";